import React from 'react';
import { useSelector } from 'react-redux';
import { isPwa } from '../../fanctionUtility';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate()
  const corso = useSelector(state => state.corso.corso);

  const auth = useSelector(state => state.auth)

  const goToCorsiSearch = () => {
    navigate('/corsi')
  }

  const goToUserList = () => {
    navigate(`/corso/${corso.id}/schedaCorso`)
  }

  const goToPresences = () => {
    navigate(`/corso/${corso.id}/presenze?tab=allievi`)
  }

  const goToProfile = () => {
    navigate(`/profilo`)
  }

  const isViewingCorso = () => {
    return corso
  }

  return isPwa() ? auth.user && (
    <footer style={{ gridArea: 'footer', backgroundColor: '#ffffff', zIndex: 100, position: 'fixed', width: '100%', bottom: 0, padding: '5px', paddingBottom: '15px' }}>
      <div className='d-flex flex-row w-full w-100 justify-content-around border-top'>
        <button onClick={goToCorsiSearch} className='btn'>
          <i className='fa fa-graduation-cap' />
          <br />
          Corsi
        </button>
        {isViewingCorso() && <button onClick={goToPresences} className='btn'>
          <i className='fa fa-check' />
          <br />
          Presenze
        </button>}
        {isViewingCorso() && <button onClick={goToUserList} className='btn'>
          <i className='fa fa-users' />
          <br />
          Utenti
        </button>}
        <button onClick={goToProfile} className='btn'>
          <i className='fa fa-user' />
          <br />
          Profilo
        </button>
      </div>
    </footer>
  ) : (
    <footer style={{ gridArea: 'footer', backgroundColor: '#e4e5e6', zIndex: 1, position: 'fixed', width: '100%', bottom: 0, padding: '5px' }}>
      <a href="http://www.regione.toscana.it">Regione Toscana - Registro Elettronico</a>
    </footer>
  )
}

export default Footer;
